module.exports = __webpack_public_path__ + "common/logistics/icon-gdex-a30198c1f6aa5a206505a3328363f861.svg";